<a
  class="menu-tree-search-result"
  [attr.href]="itemUrl"
  [attr.aria-current]="chosenElementId === item.id ? 'true' : null"
  (click)="selectResult($event)"
>
  <span>{{ item.name }}</span>
  @if (ancestorPath) {
    <span class="menu-tree-search-path">{{ ancestorPath }}</span>
  }
</a>
